import { Trans } from 'react-i18next';

import { MedicalDataAccessAuthorization } from '@dreryk/egabinet-patient-frontend-api';

import { commonTranslationKeys, TranslatableText } from '@dreryk/react-common';
import { ModalConfirmingExit, ModalWidth, StrongText } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../translations';

import { MedicalDataAccessAuthorizationModalForm } from './MedicalDataAccessAuthorizationModalForm/MedicalDataAccessAuthorizationModalForm';
import { useMedicalDataAccessAuthorizationFormController } from './MedicalDataAccessAuthorizationModalForm/MedicalDataAccessAuthorizationModalForm.hooks';
import {
   MedicalDataAccessAuthorizationFormBean,
   MedicalDataAccessAuthorizationFormValues,
} from './MedicalDataAccessAuthorizationModalForm/MedicalDataAccessAuthorizationModalForm.types';

type MedicalDataAccessAuthorizationModalProps = {
   readonly initialValues: MedicalDataAccessAuthorizationFormValues;
   readonly onSubmit: (data: MedicalDataAccessAuthorizationFormBean) => Promise<MedicalDataAccessAuthorization>;
   readonly onCancel: () => void;
   readonly modalTitle: TranslatableText;
};

const ExitConfirmationMessageComponent = (): JSX.Element => {
   return (
      <div>
         <Trans
            i18nKey={
               patientConsentsAndAuthorizationsTranslationKeys.authorizations.authorizationExitConfirmationMessage
            }
            components={{ bold: <StrongText testId={'exitConfirmationMessage'} /> }}
         />
      </div>
   );
};

const MedicalDataAccessAuthorizationModal = (props: MedicalDataAccessAuthorizationModalProps): JSX.Element => {
   const controller = useMedicalDataAccessAuthorizationFormController(props.initialValues);

   return (
      <ModalConfirmingExit
         testId={'medicalDataAccessAuthorization'}
         title={props.modalTitle}
         confirmationButtonLabel={commonTranslationKeys.save}
         wrapInForm
         onSubmit={controller.handleSubmit(props.onSubmit)}
         onCancel={props.onCancel}
         exitConfirmationTitle={patientConsentsAndAuthorizationsTranslationKeys.authorizations.authorizationLeaveForm}
         exitConfirmationMessage={<ExitConfirmationMessageComponent />}
         exitConfirmationButtonLabel={
            patientConsentsAndAuthorizationsTranslationKeys.authorizations.authorizationExitConfirmationButtonLabel
         }
         exitCancelButtonLabel={commonTranslationKeys.cancel}
         shouldConfirm={controller.formState.isDirty}
         width={ModalWidth.HUGE}
         visible
         animateVisibility
      >
         <MedicalDataAccessAuthorizationModalForm
            register={controller.register}
            watch={controller.watch}
            getValue={controller.getValue}
            setValue={controller.setValue}
            trigger={controller.trigger}
            setFocus={controller.setFocus}
         />
      </ModalConfirmingExit>
   );
};

export { MedicalDataAccessAuthorizationModal };
